// extracted by mini-css-extract-plugin
module.exports =  {"activeArrow":"activeArrow__b7PEA"};